<template>
  <el-dialog
    :title="$t('addAttrValue.addAttributeValue')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="addAttrValueInfo" :rules="rules" ref="addAttrValueForm">
      <el-form-item 
        :label="$t('addAttrValue.value')" 
        prop="value"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="addAttrValueInfo.value"
          :placeholder="$t('addAttrValue.requiredValue')"
        ></el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('addAttrValue.valueName')" 
        prop="valueName"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="addAttrValueInfo.valueName"
          :placeholder="$t('addAttrValue.requiredValueName')"
        ></el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('addAttrValue.display')" 
        prop="valueShow"
        :label-width="formLabelWidth"
      >
        <el-select 
          v-model="addAttrValueInfo.valueShow" 
          :placeholder="$t('addAttrValue.requiredDisplay')"
          style="width:100%"
        >
          <el-option 
            :label="$t('addAttrValue.yes')" 
            value="Y"
          ></el-option>
          <el-option 
            :label="$t('addAttrValue.no')" 
            value="N"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAttrValueInfo">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveAttrValue } from '@/api/dev/attrValueApi'

export default {
  name: 'AddAttrValue',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '120px',
      addAttrValueInfo: {
        specId: '',
        value: '',
        valueName: '',
        valueShow: ''
      },
      rules: {
        value: [
          { required: true, message: this.$t('addAttrValue.valueRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('addAttrValue.valueMaxLength'), trigger: 'blur' }
        ],
        valueName: [
          { required: true, message: this.$t('addAttrValue.valueNameRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('addAttrValue.valueNameMaxLength'), trigger: 'blur' }
        ],
        valueShow: [
          { required: true, message: this.$t('addAttrValue.displayRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.addAttrValueInfo.specId = params.specId
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addAttrValueForm.resetFields()
      this.addAttrValueInfo = {
        specId: '',
        value: '',
        valueName: '',
        valueShow: ''
      }
    },
    saveAttrValueInfo() {
      this.$refs.addAttrValueForm.validate(async valid => {
        if (valid) {
          try {
            await saveAttrValue(this.addAttrValueInfo)
            this.$message.success(this.$t('addAttrValue.addSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('添加属性值失败:', error)
          }
        }
      })
    }
  }
}
</script>